import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

type favoriteViewType = {
  isPhotosView: boolean;
  isRecipesView: boolean;
  isMemoriesView: boolean;
  isMomentsView: boolean;
  isFoldersView: boolean;
  isPeopleView: boolean;
  isRecipeFoldersView: boolean;
};

const initialState: favoriteViewType | null = null;

export const favoriteViewSlice = createSlice({
  name: 'favoriteViewSlice',
  initialState,
  reducers: {
    setFavoriteViewData: (state, action) => {
      state = { ...action.payload };
      return state;
    },
    resetFavoriteViewData: () => {
      return initialState;
    }
  }
});

export const { setFavoriteViewData, resetFavoriteViewData } =
  favoriteViewSlice.actions;
export const getFavoriteViewData = (state: RootState) =>
  state.favoriteViewSlice;
